import React from "react";
import _ from "lodash";
import moment from "moment";

import CurrencyConvertor from "../../global/currency-convertor";
import { toSentenceCase } from "../../../utils/formatting";
import formatFlexibleCancellationPolicy from "../../../utils/formatting/format-flexible-cancellation-policy.util";
import OfferTag from "../offer-tag";

const RoomDetailCard = ({ rateplan }) => {
  const {
    cancellationPolicy = {},

    meals = {},

    hippoOffer = 0,
    hippoOfferRate,
    rateplanDiscountRate,
    promotionDiscountRate,
    basePrice,
    finalPrice,
  } = rateplan;

  // in future custom promo will be added
  const primaryDiscountType = hippoOffer > 0 ? "hippoOffer" : "";

  const flexibleWording = formatFlexibleCancellationPolicy(cancellationPolicy);

  return (
    <div className="room-details" id="detail-cards">
      <div className="detail-cards box-border">
        <div className="detail-cards-top">
          <div className="rate-plan-details">
            {/* <h6>{toSentenceCase(cancellationPolicy.type)}</h6> */}

            {cancellationPolicy.cancellationUntilDate ? <p className="free-cancellation-text">{flexibleWording}</p> : <p>Amount paid is non-refundable</p>}

            <MealOptions meals={meals} />
          </div>

          <div className="price-details room-right-sec">
            {basePrice !== finalPrice && (
              <CurrencyConvertor
                className="compare-price"
                price={basePrice}
                // primaryDiscountType={is_custom_promo_applied && ( basePrice !== finalPrice ) ? "customPromotion" : ""}
              />
            )}

            <CurrencyConvertor className="total-price" price={finalPrice} primaryDiscountType={primaryDiscountType} />
          </div>
        </div>
        <OfferTag hippoOffer={hippoOfferRate} promotionDiscount={promotionDiscountRate} rateplanDiscount={rateplanDiscountRate} />
      </div>
    </div>
  );
};

export default RoomDetailCard;

function MealOptions({ meals, className = "included-services meals-provided" }) {
  // Collect all available meals into an array
  const mealOptions = [];
  if (meals.breakfast) mealOptions.push("Breakfast");
  if (meals.lunch) mealOptions.push("Lunch");
  if (meals.dinner) mealOptions.push("Dinner");

  if (mealOptions.length === 0) return null;

  // Convert the array into a string with proper commas and "and"
  const mealString = mealOptions.length > 1 ? mealOptions.slice(0, -1).join(", ") + " and " + mealOptions.slice(-1) : mealOptions.join("");

  return <span className={className}>{mealString} included</span>;
}

export { MealOptions };
